import { EventEmitter, Component, OnInit, Input, Output } from "@angular/core";
export interface CellListItem {
  label: string;
  value: string;
  hiddenValue?: string;
}
@Component({
    selector: 'bw-cell-list-legacy',
    templateUrl: './cell-list.component.html',
    styleUrls: ['./cell-list.component.scss'],
    standalone: false
})
export class CellListComponentLegacy implements OnInit {
  @Input() listItems: CellListItem[];

  @Output() clicked = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  private copyToClip(copyText: string) {}

  onLineClicked(item: CellListItem) {
    this.clicked.emit(item);
  }
}
